<template>
  <div class="app">
    <AppHeader/>
    <div class="app-body">
      <Sidebar :navItems="nav"/>
      <main id="main" class="main" @click="hideSidebars">
        <Categories/>
        <Notice/>
        <transition name="page" mode="out-in" appear>
          <router-view v-bind:key="$route.params.id"></router-view>
        </transition>
      </main>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import nav from '~/_nav'
import { Header as AppHeader, Sidebar, Footer as AppFooter, Breadcrumb } from '~/components/'
import Categories from '~/components/Categories'
import Notice from '~/components/Notice'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppFooter,
    Breadcrumb,
    Categories,
    Notice
  },
  data () {
    return {
      nav: nav.items
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  },
  methods: {
    hideSidebars (e) {
      document.body.classList.remove('sidebar-minimized')
      document.body.classList.remove('sidebar-mobile-show')
      document.body.classList.add('sidebar-hidden')
      document.body.classList.add('aside-menu-hidden')
    },
  },
  
  watch: {
    '$route' (to, from) {
      this.hideSidebars()
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/layouts/full.vue